module.exports = __webpack_public_path__ + "static/media/h3.afb92610.svg";